import { Component, Input } from '@angular/core';
import { IOrderMenuTag } from '../../models/order-menu.models';

@Component({
  selector: 'v2-item-tags-full',
  templateUrl: 'v2-item-tags-full.component.html',
  styleUrls: ['v2-item-tags-full.component.scss']
})
export class V2ItemTagsFull {
  @Input() tags: IOrderMenuTag[] = [];
}
